export default function CTABanner() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20luxury%20residential%20building%20exterior%20at%20dusk%2C%20modern%20sophisticated%20architecture%20with%20warm%20lighting%2C%20premium%20high-end%20property%2C%20professional%20real%20estate%20photography%2C%20desaturated%20calm%20tones%2C%20clean%20composition%20with%20simple%20background%2C%20twilight%20atmosphere%2C%20architectural%20excellence&width=1920&height=1080&seq=cta-banner-001&orientation=landscape"
          alt="Premium consultation"
          className="w-full h-full object-cover object-center"
          style={{ filter: 'saturate(0.8)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/50 to-black/60"></div>
      </div>

      <div className="relative z-10 text-center text-white">
        <h2
          className="text-[64px] font-bold tracking-[0.25em] mb-10"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          プレミアム不動産コンサルテーション
        </h2>

        <p
          className="text-[15px] font-light leading-relaxed opacity-85 mb-16"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          お客様の理想の住まい探しを、経験豊富な専門スタッフがサポートいたします。
          <br />
          まずはお気軽にご相談ください。初回相談は無料で承っております。
        </p>

        <button
          onClick={scrollToContact}
          className="group inline-flex items-center gap-4 w-[260px] h-16 px-8 bg-[#1A1A1A] text-white rounded-full text-[15px] tracking-[0.12em] font-medium hover:bg-[#2A2A2A] transition-all duration-300 shadow-xl whitespace-nowrap cursor-pointer"
          style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
        >
          <div className="w-10 h-10 rounded-full bg-[#D97642] flex items-center justify-center flex-shrink-0">
            <i className="ri-briefcase-line text-white text-xl"></i>
          </div>
          <span>ご相談はこちら</span>
          <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform"></i>
        </button>
      </div>
    </section>
  );
}
